/* Nelvera Lymph — storefront behaviour (v3)
   Everything here is progressive enhancement: with JS or GSAP blocked,
   every price, button and section still works and stays visible. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia && matchMedia('(min-width: 901px) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- country / currency selector ---------------- */
  function initLocalization(scope) {
    $$('[data-loc-select]', scope).forEach(function (sel) {
      if (sel._nv) return; sel._nv = 1;
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------------- sticky header shadow ---------------- */
  function initHeader() {
    var h = $('[data-header]'); if (!h) return;
    var on = false;
    window.addEventListener('scroll', function () {
      var s = window.scrollY > 8;
      if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); }
    }, { passive: true });
  }

  /* ---------------- gallery ---------------- */
  function showSlide(gal, id) {
    if (!gal || !id) return;
    var target = $('[data-slide="' + id + '"]', gal); if (!target) return;
    $$('[data-slide]', gal).forEach(function (s) {
      var on = s === target;
      s.hidden = !on; s.classList.toggle('is-on', on);
    });
    $$('[data-thumb]', gal).forEach(function (t) {
      var on = t.dataset.thumb === String(id);
      t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on);
    });
    if (window.gsap && !reduce) gsap.fromTo(target, { opacity: 0, scale: .985 }, { opacity: 1, scale: 1, duration: .45, ease: 'power2.out' });
    if (target.querySelector('model-viewer')) loadModelViewer();
  }
  function initGallery(scope) {
    $$('[data-gallery]', scope).forEach(function (gal) {
      $$('[data-thumb]', gal).forEach(function (t) {
        t.addEventListener('click', function () { showSlide(gal, t.dataset.thumb); });
      });
    });
  }
  var mvLoaded = false;
  function loadModelViewer() {
    if (mvLoaded || !window.Shopify || !Shopify.loadFeatures) return;
    mvLoaded = true;
    Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function () {} }, { name: 'shopify-xr', version: '1.0', onLoad: function () {} }]);
  }

  /* hero bottle: subtle 3D tilt that follows the pointer (desktop only) */
  function initTilt(scope) {
    if (reduce || !isDesktop) return;
    $$('[data-tilt]', scope).forEach(function (el) {
      var stage = el.closest('[data-stage]') || el;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 10) + 'deg) translateZ(0)';
        el.style.setProperty('--gx', (50 + x * 60) + '%'); el.style.setProperty('--gy', (30 + y * 60) + '%');
      });
      stage.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------------- bundle picker ---------------- */
  function initBuy(scope) {
    var box = $('#buy', scope) || (scope && scope.id === 'buy' ? scope : null);
    if (!box) box = $('#buy'); if (!box || box._nv) return; box._nv = 1;
    var tiers = $$('.tier', box);
    var atc = $('#atc', box), label = atc && $('[data-atc-label]', atc);
    var save = $('#save'), stp = $('#stp'), input = $('[data-variant-input]', box);
    var gal = $('[data-gallery]', box);
    var kl = $('[data-klarna-line]'), klBox = kl && kl.closest('[data-klarna-text]'), stk = $('#stk');
    var protect = $('[data-protect]', box);

    function pick(t, fromUser) {
      if (!t || t.classList.contains('off')) return;
      tiers.forEach(function (x) { var on = x === t; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); x.tabIndex = on ? 0 : -1; });
      var d = t.dataset, q = d.q;
      if (input && d.variant) input.value = d.variant;
      if (label && d.price) label.textContent = (atc.dataset.cta || 'Add to cart') + ' · ' + d.price;
      if (stp && d.price) stp.textContent = q + (q === '1' ? ' bottle' : ' bottles') + ' · ' + d.price;
      if (save) {
        var main = d.save ? (save.dataset.shipText || '').replace('[save]', d.save).replace('[q]', q) : (save.dataset.noshipText || '');
        if (d.save && d.free !== 'true') main = main.split(' · ')[0];
        var pd = save.dataset.perdayText && d.perDay ? save.dataset.perdayText.replace('[per_day]', d.perDay).replace('[days]', d.days) : '';
        save.textContent = main;
        if (pd) { var s = document.createElement('span'); s.className = 'pd'; s.textContent = pd; save.appendChild(s); }
      }
      if (kl && d.split) {
        var kt = (klBox.dataset.klarnaText || '').split('[amount]');
        var n = String(klBox.dataset.n || '4');
        kl.textContent = '';
        kl.appendChild(document.createTextNode(kt[0].replace('[n]', n)));
        var b = document.createElement('b'); b.textContent = d.split; kl.appendChild(b);
        if (kt[1]) kl.appendChild(document.createTextNode(kt[1].replace('[n]', n)));
        if (stk) stk.textContent = 'or ' + n + ' × ' + d.split + ' with Klarna';
      }
      if (fromUser) {
        if (gal && d.media) showSlide(gal, d.media);
        if (window.gsap && !reduce && label) gsap.fromTo(label, { y: 6, opacity: .4 }, { y: 0, opacity: 1, duration: .3, ease: 'power2.out' });
      }
    }
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t, true); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'Enter' || k === ' ') { e.preventDefault(); pick(t, true); return; }
        if (k === 'ArrowRight' || k === 'ArrowDown') n = tiers[(i + 1) % tiers.length];
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = tiers[(i - 1 + tiers.length) % tiers.length];
        if (n) { e.preventDefault(); pick(n, true); n.focus(); }
      });
    });
    pick($('.tier.on', box) || tiers[0], false);

    /* add to cart, then show the cart drawer (cart step before checkout) */
    var form = $('[data-buy-form]', box);
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (!$('[data-cart-drawer]')) return; /* no drawer: normal form post to the cart page */
        e.preventDefault();
        if (form.dataset.busy) return;
        form.dataset.busy = '1';
        var txt = label ? label.textContent : '';
        if (atc) atc.disabled = true;
        if (label) label.textContent = 'Adding…';
        var items = [{ id: Number(input.value), quantity: 1 }];
        cartState().then(function (cart) {
          if (protect && protect.checked && !cart.items.some(function (i) { return String(i.variant_id) === String(protect.value); })) {
            items.push({ id: Number(protect.value), quantity: 1 });
          }
          return cartPost('cart/add.js', { items: items });
        }).then(function () {
          if (label) label.textContent = 'Added ✓';
          return refreshCart();
        }).then(function () {
          openCart();
          setTimeout(function () { if (label) label.textContent = txt; }, 900);
        }).catch(function () {
          if (label) label.textContent = txt;
          HTMLFormElement.prototype.submit.call(form);
        }).then(function () { delete form.dataset.busy; if (atc) atc.disabled = false; });
      });
    }

    /* sticky bar on mobile once the main button has scrolled away */
    var st = $('#sticky');
    if (st && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        st.classList.toggle('show', show); st.setAttribute('aria-hidden', !show);
      }).observe(atc);
    }
  }

  /* ---------------- cart drawer ---------------- */
  var lastFocus = null;
  function cartPost(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(path); return r.json(); });
  }
  function cartState() { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshCart() {
    return Promise.all([
      fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      cartState()
    ]).then(function (res) {
      var html = res[0]['cart-drawer'], cart = res[1];
      var cur = $('[data-cart-drawer]');
      if (html && cur) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        if (fresh) {
          var wasOpen = cur.classList.contains('is-open');
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen) cur.classList.add('is-open');
        }
      }
      $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = !cart.item_count; });
      return cart;
    });
  }
  function openCart() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-lock');
    var p = $('.cd__panel', d); if (p) setTimeout(function () { p.focus(); }, 50);
  }
  function closeCart() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initCartDrawer() {
    var d = $('[data-cart-drawer]'); if (!d || d._nv) return; d._nv = 1;
    /* one delegated listener survives every re-render of the drawer */
    d.addEventListener('click', function (e) {
      var t = e.target.closest('button, a'); if (!t || !d.contains(t)) return;
      if (t.hasAttribute('data-cart-close')) { if (t.tagName === 'BUTTON') e.preventDefault(); closeCart(); return; }
      var line = t.closest('[data-line]');
      if (t.hasAttribute('data-qty') && line) {
        e.preventDefault(); d.classList.add('is-busy');
        cartPost('cart/change.js', { line: Number(line.dataset.line), quantity: Number(t.dataset.qty) })
          .then(refreshCart).catch(function () {}).then(function () { d.classList.remove('is-busy'); });
        return;
      }
      if (t.hasAttribute('data-add-variant')) {
        e.preventDefault(); d.classList.add('is-busy');
        cartPost('cart/add.js', { items: [{ id: Number(t.dataset.addVariant), quantity: 1 }] })
          .then(refreshCart).catch(function () {}).then(function () { d.classList.remove('is-busy'); });
      }
    });
    d.addEventListener('click', function (e) { if (e.target.classList && e.target.classList.contains('cd__overlay')) closeCart(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.classList.contains('is-open')) closeCart(); });
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
  }

  /* ---------------- delivery estimate: concrete dates beat "7–12 days" ---------------- */
  function initEta(scope) {
    $$('[data-eta]', scope).forEach(function (el) {
      if (el._nv) return; el._nv = 1;
      var span = el.querySelector('span'); if (!span) return;
      var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      var fmt = function (d) { try { return d.toLocaleDateString(document.documentElement.lang || 'en', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); } };
      var tpl = span.textContent, parts = tpl.split(/\[from\]|\[to\]/);
      if (parts.length < 3) return;
      span.textContent = parts[0];
      var b1 = document.createElement('b'); b1.textContent = fmt(add(Number(el.dataset.min) || 8)); span.appendChild(b1);
      span.appendChild(document.createTextNode(parts[1]));
      var b2 = document.createElement('b'); b2.textContent = fmt(add(Number(el.dataset.max) || 15)); span.appendChild(b2);
      span.appendChild(document.createTextNode(parts[2]));
    });
  }

  /* ---------------- order tracking (17TRACK) ---------------- */
  function initTrack(scope) {
    var tf = $('[data-track-form]', scope); if (!tf || tf._nv) return; tf._nv = 1;
    tf.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = (tf.querySelector('input').value || '').replace(/\s+/g, '');
      if (n) window.location.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(n);
    });
  }

  /* ---------------- interactive lymph-flow diagram ----------------
     Teaches the mechanism: dots crawl up the vessel when "sitting",
     and flow fast while the calf "pump" beats when "moving". */
  function initFlow(scope) {
    $$('[data-mech]', scope).forEach(function (sec) {
      if (sec._nv) return; sec._nv = 1;
      var btns = $$('[data-flow]', sec), caps = $$('[data-cap-still]', sec);
      var g = $('.dots', sec), path = g && $(g.dataset.path, sec), dots = g ? $$('circle', g) : [];
      var tl = null, pump = null;
      var canAnimate = window.gsap && window.MotionPathPlugin && path && !reduce;
      if (canAnimate) {
        gsap.registerPlugin(MotionPathPlugin);
        tl = gsap.timeline({ repeat: -1, paused: true });
        dots.forEach(function (d, i) {
          tl.to(d, { motionPath: { path: path, align: path, alignOrigin: [.5, .5], start: 0, end: 1 }, duration: 4, ease: 'none', repeat: -1 }, i * (4 / dots.length));
        });
        tl.timeScale(.18);
        pump = gsap.to($('.pump', sec), { scale: 1.12, transformOrigin: '50% 50%', duration: .35, yoyo: true, repeat: -1, ease: 'sine.inOut', paused: true });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) { en[0].isIntersecting ? tl.play() : tl.pause(); }).observe(sec);
        } else { tl.play(); }
      } else if (path && dots.length) {
        /* static fallback: spread the dots along the vessel */
        var L = path.getTotalLength();
        dots.forEach(function (d, i) { var p = path.getPointAtLength(L * i / dots.length); d.setAttribute('cx', p.x); d.setAttribute('cy', p.y); });
      }
      function set(state) {
        var moving = state === 'move';
        sec.classList.toggle('is-moving', moving);
        btns.forEach(function (b) { var on = b.dataset.flow === state; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
        caps.forEach(function (c) { c.textContent = moving ? c.dataset.capMove : c.dataset.capStill; });
        if (tl) gsap.to(tl, { timeScale: moving ? 1.6 : .18, duration: .8, ease: 'power2.out' });
        if (pump) moving ? pump.play() : (pump.pause(), gsap.to($('.pump', sec), { scale: 1, duration: .2 }));
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.dataset.flow); }); });
    });
  }

  /* ---------------- scroll storytelling (GSAP) ----------------
     Every animation has a job: guide the eye to the next idea.
     Nothing is hidden by CSS, so content stays visible if GSAP fails. */
  function splitWords(el) {
    if (el._split) return el._split;
    var out = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span'); s.className = 'w'; s.textContent = part; frag.appendChild(s); out.push(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    })(el);
    el._split = out; return out;
  }
  function initMotion(scope) {
    if (reduce || !window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    var ctx = scope || document;

    /* hero entrance */
    var heroBits = $$('.buy [data-reveal]', ctx);
    if (heroBits.length && !ctx._heroDone) {
      ctx._heroDone = 1;
      gsap.from(heroBits, { y: 18, opacity: 0, duration: .7, stagger: .07, ease: 'power3.out', delay: .05 });
      gsap.from($$('.gallery .hero-img', ctx), { y: 30, opacity: 0, scale: .96, duration: 1, ease: 'power3.out' });
    }
    /* parallax leaves */
    $$('[data-parallax]', ctx).forEach(function (el) {
      gsap.to(el, { y: Number(el.dataset.parallax), ease: 'none', scrollTrigger: { trigger: el.closest('[data-stage]') || el, start: 'top top', end: 'bottom top', scrub: true } });
    });
    /* headings: word-by-word rise */
    $$('[data-split]', ctx).forEach(function (h) {
      var w = splitWords(h);
      gsap.from(w, { yPercent: 60, opacity: 0, duration: .7, stagger: .035, ease: 'power3.out', scrollTrigger: { trigger: h, start: 'top 85%', once: true } });
    });
    /* single reveals outside the hero */
    $$('[data-reveal]', ctx).forEach(function (el) {
      if (el.closest('.buy')) return;
      gsap.from(el, { y: 24, opacity: 0, duration: .8, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });
    /* card grids: staggered */
    $$('[data-stagger]', ctx).forEach(function (grid) {
      gsap.from(grid.children, { y: 34, opacity: 0, duration: .7, stagger: .09, ease: 'power3.out', scrollTrigger: { trigger: grid, start: 'top 85%', once: true } });
    });
    /* timeline: the line draws itself, stages follow it */
    $$('[data-timeline]', ctx).forEach(function (tlEl) {
      var t = gsap.timeline({ scrollTrigger: { trigger: tlEl, start: 'top 80%', once: true } });
      t.fromTo(tlEl, { '--tl': 0 }, { '--tl': 1, duration: 1.1, ease: 'power2.inOut' })
       .from(tlEl.children, { y: 20, opacity: 0, stagger: .18, duration: .6, ease: 'power2.out' }, .2);
    });
    /* guarantee seal stamps in */
    $$('[data-seal]', ctx).forEach(function (s) {
      gsap.from(s, { rotate: -25, scale: .6, opacity: 0, duration: .9, ease: 'back.out(1.7)', scrollTrigger: { trigger: s, start: 'top 85%', once: true } });
    });
  }

  /* ---------------- boot + theme editor support ---------------- */
  function init(scope) {
    initLocalization(scope); initGallery(scope); initTilt(scope); initBuy(scope);
    initTrack(scope); initFlow(scope); initEta(scope);
  }
  function boot() {
    initHeader(); initCartDrawer(); init(document);
    if (window.gsap) initMotion(document);
    else window.addEventListener('load', function () { initFlow(document); initMotion(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* the theme editor re-renders sections without reloading: re-bind them */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (window.ScrollTrigger) { initMotion(e.target); ScrollTrigger.refresh(); }
  });
})();
